module.exports = __webpack_public_path__ + "img/34.da7adb7b.jpg";